import {Attachment} from '@hconnect/common/types'
import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient, useMutation} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {deleteAttachment, QueryKeyName} from '../../common/backend'
import {FEATURE_NAMESPACE} from '../../consts'

interface DeleteAttachmentArgs {
  plantId: string
  questionId: string
  attachment: Attachment
}

export const useDeleteQuestionAttachment = () => {
  const {t} = useTranslation(FEATURE_NAMESPACE)
  const client = useQueryClient()

  return useMutation({
    mutationFn: ({plantId, questionId, attachment}: DeleteAttachmentArgs) => {
      return deleteAttachment({plantId, questionId, documentId: attachment.url})
    },
    onSuccess: () => {
      void client.invalidateQueries({queryKey: [QueryKeyName.GetQuestions]})
      spawnSuccessToast(t('attachments.deleted.success'))
    },
    onError: () => {
      spawnErrorToast(t('attachments.deleted.error'))
    }
  })
}
